import { render } from "./Grupos.vue?vue&type=template&id=2b1bbef7"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\DevOps\\Planner\\FRONT_Planner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__